import "./ErrorPage.css";

function Unauthorized() {
  return <div className="errMessege">Unauthorized Access</div>;
}

export default Unauthorized;
